import { CreateTaskRequest, Task, UpdateTaskRequest } from '../types';
import { PaginationParams } from '../core/http';
import { BaseService } from './BaseService';

export class TaskService extends BaseService<
  Task,
  CreateTaskRequest,
  UpdateTaskRequest
> {
  constructor() {
    super('/v1/tasks');
  }

  async getByAgent(agentId: number, pagination?: PaginationParams): Promise<Task[]> {
    const response = await this.getAll({ agent_id: agentId, ...pagination });
    return response.items;
  }

  async getUnassigned(pagination?: PaginationParams): Promise<Task[]> {
    const response = await this.getAll({ unassigned_only: true, ...pagination });
    return response.items;
  }

  async getActiveByAgent(
    agentId: number,
    pagination?: PaginationParams
  ): Promise<Task[]> {
    const response = await this.getAll({
      agent_id: agentId,
      active_only: true,
      ...pagination,
    });
    return response.items;
  }

  async assignToAgent(taskId: number, agentId: number): Promise<Task> {
    return this.update(taskId, { agent_id: agentId });
  }

  async unassignFromAgent(taskId: number): Promise<Task> {
    return this.update(taskId, { agent_id: null });
  }
}
